import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../header"
import Footer from "../footer";
import './style.scss'

const Layout: React.FC = () => {
  return (
    <main>
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
};

export default Layout;
